import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageEditHeaderWithActionBar from '@/components/common/Header/PageEditHeaderWithActionBar.vue'
import WriteContainer from '@calendar/containers/WriteContainer.vue'
@Component({
    components: { PageEditHeaderWithActionBar, WriteContainer }
})
export default class WriteView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    save() {
        (this.$refs.writeContainer as any).save()
    }
}
